exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hanging-frame[data-v-90fc88f0]{display:inline-block;border:10px solid #000;box-shadow:2px 2px 10px 0 #777;overflow:hidden}.inner[data-v-90fc88f0]{border:20px solid #fff}.large .inner[data-v-90fc88f0]{border:50px solid #fff}.full[data-v-90fc88f0]{display:block}.full .inner[data-v-90fc88f0]{border:0}svg[data-v-90fc88f0]{width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-90fc88f0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/hanging-frame/style.scss
// module id = 909
// module chunks = 0